import React from 'react';

const Overview: React.FC = () => {
  return (
    <section id="overview">
      <h2>Overview</h2>
      <img src="/main_page.jpg" alt="Chalo Dilli Paratha Cafe" className="overview-image" />
      <p>
        <span style={{ fontWeight: 'bold', color: '#FFD700' }}>Chalo Dilli Paratha Café</span> brings the true taste
        of Delhi’s streets to Pune.
        <br />
        <br />
        From Chandni Chowk–style parathas to iconic chaat and Dahi Jalebi, every bite feels like Delhi.
        <br />
        <br />
        We serve freshly prepared, authentic North Indian comfort food made with love.
        <br />
        Perfect for family outings, quick bites, and food lovers seeking real Delhi flavours.
        <br />
        Dine in, takeaway.
        <br />
        <br />
        <span
          style={{
            display: 'inline-block',
            marginTop: '0.5rem',
            padding: '0.6rem 1.4rem',
            borderRadius: '999px',
            backgroundColor: '#FFD700',
            color: '#000000',
            fontWeight: '600',
            cursor: 'pointer',
          }}
        >
          Book us for Birthday Parties, kitty events, and Catering
        </span>
      </p>
      <h3>Follow Us:</h3>
      <div className="overview-social-links">
        <a href="https://www.facebook.com/ChaloDilliParathaCafe" target="_blank" rel="noopener noreferrer" aria-label="Facebook">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 16 16" fill="currentColor">
            <path d="M16 8.049c0-4.446-3.582-8.05-8-8.05C3.58 0-.002 3.603-.002 8.05c0 4.017 2.926 7.347 6.75 7.951v-5.625h-2.03V8.05H6.75V6.275c0-2.017 1.195-3.131 3.022-3.131.876 0 1.791.157 1.791.157v1.98h-1.009c-.993 0-1.303.621-1.303 1.258v1.51h2.218l-.354 2.326H9.25V16c3.824-.604 6.75-3.934 6.75-7.951"/>
          </svg>
        </a>
        <a href="https://www.instagram.com/chalodilliparathacafe/?igsh=MzRlODBiNWFlZA%3D%3D#" target="_blank" rel="noopener noreferrer" aria-label="Instagram">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
            <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.07 1.645.07 4.85s-.012 3.584-.07 4.85c-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07s-3.585-.012-4.85-.07c-3.254-.148-4.771-1.691-4.919-4.919-.058-1.265-.07-1.644-.07-4.85s.012-3.585.07-4.85c.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.07 4.85-.07zm0-2.163c-3.259 0-3.668.014-4.949.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.949.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.073 4.948.073s3.668-.014 4.949-.072c4.354-.2 6.782-2.618 6.979-6.98.059-1.281.073-1.689.073-4.948 0-3.259-.014-3.668-.072-4.949-.198-4.357-2.618-6.78-6.98-6.98-1.281-.059-1.689-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.162 6.162 6.162 6.162-2.759 6.162-6.162c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4s1.791-4 4-4 4 1.79 4 4-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
          </svg>
        </a>
          <a href="https://share.google/mI02tGTD0fhogstRh" target="_blank" rel="noopener noreferrer" aria-label="Google">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
            <path d="M22.445 12.276c0-.79-.068-1.493-.195-2.179H12v4.102h5.922c-.26 1.376-1.04 2.53-2.213 3.317v2.68h3.453c2.026-1.866 3.19-4.605 3.19-7.92z"/>
            <path d="M12 23c3.24 0 5.94-1.07 7.92-2.91l-3.453-2.68c-.96.64-2.19 1.02-3.467 1.02-2.66 0-4.92-1.79-5.73-4.21H2.81v2.76C4.81 21.29 8.13 23 12 23z"/>
            <path d="M6.27 14.21c-.23-.64-.36-1.32-.36-2.03s.13-1.39.36-2.03V7.42H2.81c-.77 1.54-.77 3.35 0 4.9z"/>
            <path d="M12 4.75c1.45 0 2.74.5 3.76 1.47l3.06-2.99C17.94 1.19 15.19 0 12 0 8.13 0 4.81 1.71 2.81 4.75L6.27 7.42c.81-2.42 3.07-4.21 5.73-4.21z"/>
          </svg>
        </a>
      </div>
    </section>
  );
};

export default Overview;
